// Typelizer digest aab891f4fdf334b27a431e849cd6aeff
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /c/:company_id/account/edit */
  edit: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/account/edit', {}, options),
    method: 'get',
  }),

  /** GET /c/:company_id/account */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/c/:company_id/account', {}, options),
    method: 'get',
  }),

  /** PATCH /c/:company_id/account */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/c/:company_id/account', {}, options),
    method: 'patch',
  }),
}
